import { utilsModule } from "../utils-module";
import {ordersApi} from '../../../ordersApi'


utilsModule.factory('currentTags', ['$q', 'productList', 'Etiqueta', 'Lote', 'fileUtilsService', 'reportsService', 'localStorageService', 'dialogs',function ($q, productList, Etiqueta, Lote, fileUtilsService, reportsService, localStorageService, dialogs) {

    return {
        client: undefined,
        itens: [],

        reset: function () {
            this.client = undefined;
            this.itens = [];
            this.tagType = 2;
            this.nomeCliente = undefined;
            this.descricaoLocal = '';

            if (productList && productList.list) {
                productList.list.forEach((prod) => {
                    delete prod.$tagData;
                });
            }
        },

        isProductAdded: function (product) {
            if (typeof product == "string") {
                var found = productList.list.filter((prod) => {
                    return (prod.id == product);
                })
                product = (found.length > 0) ? found[0] : undefined;
            }
            return product.$tagData && (product.$tagData.quantidade > 0);
        },

        getProductQuantityAdded: function (product) {
            if (typeof product == "string") {
                var found = productList.list.filter((prod) => {
                    return (prod.id == product);
                })
                product = (found.length > 0) ? found[0] : undefined;
            }

            return (product && product.$tagData) ? (product.$tagData.quantidade || 0) : 0;
        },

        getProductSelectedTagModel: function (product) {
            if (typeof product == "string") {
                var found = productList.list.filter((prod) => {
                    return (prod.id == product);
                })
                product = (found.length > 0) ? found[0] : undefined;
            }

            return (product && product.$tagData) ? (product.$tagData.modeloEtiqueta) : undefined;
        },

        getSelectedItens: function () {
            if (!productList.list) {
                productList.list = [];
            }
            return productList.list.filter(function (item) {
                return this.isProductAdded(item);
            }.bind(this))
        },

        itensCount: function () {
            return this.getSelectedItens().length;
        },

        saveCurrentTags: function (format) {
            var self = this;
            var tags = this.getSelectedItens().map((item) => {
                item.$tagData.produto = { id: item.id };
                item.$tagData.OWNER_ID = localStorageService.get('ownerId');
                return item.$tagData;
            });

            var lotsToCheckOrCreate = [];
            var lotsToGenerate = [];
            var tagsWaitingLot = [];

            if ((self.tagType == 1) &&
                ((!self.client) ||
                    (!self.client.id) ||
                    (
                        (self.client.id == 1) &&
                        (!self.nomeCliente)
                    )
                )) {
                return $q.reject({ errorMessageCode: 'INFORM_CLIENT' });
            }

            tags.forEach((tag) => {
                if(tag.dataValidade == undefined)
                    tag.dataValidade = null
                tag.cliente = this.client;
                tag.nomeCliente = this.nomeCliente;
                tag.descricaoLocal = this.descricaoLocal;
                switch (self.tagType) {
                    case 1:
                        tag.tipoEtiqueta = 'CLIENTE';
                        break;
                    case 2:
                        tag.tipoEtiqueta = 'PROPRIA';
                        break;
                }

                if (this.tagType == 2) {
                    this.client = undefined;
                    this.nomeCliente = '';
                    this.descricaoLocal = '';
                }

                if (tag.tipoLote == 1) {
                    //Facilita a busca
                    tagsWaitingLot[tag.produto.id] = tag;
                    lotsToGenerate.push(tag.produto.id);
                } else {
                    if ((!tag.numeroLote) || (tag.numeroLote == "")) {
                        tag.lote = undefined;
                    } else {
                        //Facilita a busca
                        tagsWaitingLot[tag.produto.id] = tag;
                        lotsToCheckOrCreate.push({
                            numero: tag.numeroLote,
                            produto: { id: tag.produto.id }
                        })
                    }
                }
            }, this);

            var promiseList = [];
            var p1 = undefined;
            var p2 = undefined;
            // Para produtos com a opção "Gerar Lote", gera um novo numero
            if (lotsToGenerate.length > 0) {
                p1 = Lote.generateNewLot({ productIds: lotsToGenerate, OWNER_ID:localStorageService.get('ownerId') }).$promise;
                promiseList.push(p1)
            }
            // Para os demais, obtém a instancia, caso o lote iformado exista, ou cria uma, caso nao exista
            if (lotsToCheckOrCreate.length > 0) {
                p2 = Lote.loadOrCreateLots({ lotList: lotsToCheckOrCreate }).$promise;
                promiseList.push(p2)
            }

            return $q.all(promiseList)
                .then((data) => {
                    
                    var lotList = [];
                    if (data && (data.length > 0)) {
                        data.forEach((result) => {
                            lotList = lotList.concat(result.data);
                        })
                    }

                    lotList.forEach((lot) => {
                        tagsWaitingLot[lot.ID_PRODUTO].lote = lot;
                    });

                    tags.forEach((tag, i) => {
                        tag._ID_OFFSET = i;
                    })

                    //@TODO
                    // hack temporário para setar manualmente as propriedades produtoId e loteId
                    // setar os objetos produto e lote ao invés dos ids estava causando problemas ao salvar no banco do mongo
                    // o relacionamento da etiqueta com produto e lote não estava inserindo o ObjectId
                    // jonathan

                    tags.forEach(tag => {
                        tag.produtoId = tag.produto.id;
                        delete(tag.produto);
                        tag.loteId = tag.lote.id;
                        delete(tag.lote)
                        if(tag.cliente){
                            tag.clienteId = tag.cliente.id;
                            delete(tag.cliente);
                        }                        
                    })

                    return Etiqueta.createMany(tags).$promise
                        .then((tags) => {
                            var tagIds = tags.map((tag) => {
                                return tag.id
                            });

                            /*return Etiqueta.printTag({tagIds:tagIds}).$promise.then(()=>{
                                self.reset();
                            }) */
                            return ordersApi.post('/Etiquetas/generateTag',{tagIds:tagIds,format: format})
                                .then((response) => {
                                    self.reset();
                                    var rel = response.data.data[0];
                                    fileUtilsService.openPdf(reportsService.getTagReportUrl(rel))
                                })
                        })
                });
        }
    }
}])